/* ============================================================
   Nerosà London — Custom Navigation Header
   File: assets/nerosa-header.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Helpers ────────────────────────────────────────────── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ── Announcement bar — seamless continuous marquee ─────── */
  function initAnnouncement() {
    var track = $('#nerosa-ann-track');
    if (!track) return;
    var inner = track.querySelector('.nerosa-ann-inner');
    if (!inner) return;

    /* Clone so we have [original][clone] — animation scrolls by exactly
       one inner's pixel width so the seam is completely invisible */
    var clone = inner.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);

    /* Double rAF ensures the browser has finished layout before we measure */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var w = inner.offsetWidth;
        if (!w) return;
        var pxPerSec = 50;
        var dur = Math.round(w / pxPerSec);
        /* Set exact pixel shift — NOT -50% — so loop point is perfect */
        track.style.setProperty('--nerosa-marquee-shift', '-' + w + 'px');
        track.style.setProperty('--nerosa-marquee-dur',   dur + 's');
        track.classList.add('is-ready');
      });
    });
  }

  /* ── Desktop dropdown toggle ────────────────────────────── */
  function initDropdowns() {
    var triggers = $$('[data-dropdown]');

    function closeAll() {
      triggers.forEach(function (btn) {
        var id  = btn.getAttribute('data-dropdown');
        var dd  = $('#nerosa-dd-' + id);
        var ni  = btn.closest('.nerosa-ni');
        btn.setAttribute('aria-expanded', 'false');
        if (dd)  dd.setAttribute('hidden', '');
        if (ni)  ni.classList.remove('is-open');
      });
      hideBackdrop();
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var id     = btn.getAttribute('data-dropdown');
        var dd     = $('#nerosa-dd-' + id);
        var ni     = btn.closest('.nerosa-ni');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        closeAll();

        if (!isOpen && dd) {
          btn.setAttribute('aria-expanded', 'true');
          dd.removeAttribute('hidden');
          if (ni) ni.classList.add('is-open');
          showBackdrop(closeAll);
        }
      });
    });

    /* Close on outside click */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nerosa-ni')) closeAll();
    });

    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ── Backdrop ───────────────────────────────────────────── */
  function showBackdrop(cb) {
    var bd = $('#nerosa-backdrop');
    if (!bd) return;
    bd.removeAttribute('hidden');
    bd.onclick = function () { if (cb) cb(); };
  }

  function hideBackdrop() {
    var bd = $('#nerosa-backdrop');
    if (bd) bd.setAttribute('hidden', '');
  }

  /* ── Scroll behaviour: nav stays transparent, sticky via CSS ── */
  function initScrollBehaviour() {
    /* Nav background is always transparent on desktop.
       The .header-section position:sticky in nerosa-header.css
       handles the "follow while scrolling" behaviour.
       No JS toggling needed. */
  }

  /* ── Desktop search overlay ─────────────────────────────── */
  function initSearch() {
    var trigger  = $('#nerosa-search-trigger');
    var overlay  = $('#nerosa-search-overlay');
    var closeBtn = $('#nerosa-search-close');
    var input    = overlay ? overlay.querySelector('.nerosa-search-input') : null;

    if (!trigger || !overlay) return;

    function openSearch() {
      overlay.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      if (input) {
        setTimeout(function () { input.focus(); }, 50);
      }
    }

    function closeSearch() {
      overlay.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closeSearch();
    });
  }

  /* ── Mobile drawer ──────────────────────────────────────── */
  function initMobileDrawer() {
    var openBtn  = $('#nerosa-mob-open');
    var closeBtn = $('#nerosa-mob-close');
    var drawer   = $('#nerosa-mob-drawer');
    var backdrop = $('#nerosa-backdrop');

    if (!drawer) return;

    function lockScroll()   { document.body.style.overflow = 'hidden'; }
    function unlockScroll() { document.body.style.overflow = ''; }

    function openDrawer() {
      drawer.removeAttribute('hidden');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      lockScroll();
      /* Backdrop */
      if (backdrop) {
        backdrop.removeAttribute('hidden');
        backdrop.onclick = closeDrawer;
      }
      /* Trigger reflow so transition fires */
      drawer.offsetHeight;
    }

    function closeDrawer() {
      /* Close after transition */
      drawer.setAttribute('hidden', '');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      unlockScroll();
      hideBackdrop();
    }

    if (openBtn)  openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) closeDrawer();
    });
  }

  /* ── Mobile tabs ────────────────────────────────────────── */
  function initMobileTabs() {
    var tabs   = $$('.nerosa-mob-tab');
    var panels = $$('.nerosa-mob-tab-panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.tab;

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.add('nerosa-mob-tab-panel--hidden');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        var panel = $('#nerosa-tab-' + target);
        if (panel) panel.classList.remove('nerosa-mob-tab-panel--hidden');
      });
    });
  }

  /* ── Cart count refresh (Shopify AJAX) ─────────────────── */
  function initCartCount() {
    /* Update cart badge when cart changes via AJAX */
    document.addEventListener('cart:updated', function (e) {
      var count = e.detail && e.detail.itemCount;
      updateBadge(count);
    });

    /* Also poll via Shopify cart.js for stores using 3rd party apps */
    function fetchCount() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (data) { updateBadge(data.item_count); })
        .catch(function () {});
    }

    function updateBadge(count) {
      var badges = $$('.nerosa-cart-badge, #nerosa-cart-badge, #nerosa-mob-cart-badge');
      badges.forEach(function (el) {
        if (count > 0) {
          el.textContent = count;
          el.classList.remove('nerosa-cart-badge--hidden');
        } else {
          el.textContent = '0';
          el.classList.add('nerosa-cart-badge--hidden');
        }
      });
    }

    /* Intercept Shopify native cart events */
    var origFetch = window.fetch;
    window.fetch = function () {
      return origFetch.apply(this, arguments).then(function (response) {
        var url = arguments[0] && (arguments[0].url || arguments[0]);
        if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change'))) {
          setTimeout(fetchCount, 300);
        }
        return response;
      });
    };
  }

  /* ── Init all ───────────────────────────────────────────── */
  function init() {
    /* Add template class to body so CSS can target per-template */
    var main = document.getElementById('MainContent');
    if (main) {
      var tmpl = main.getAttribute('data-template') || '';
      document.body.classList.add('template-' + tmpl.replace(/\//g, '-'));
    }

    initAnnouncement();
    initDropdowns();
    initScrollBehaviour();
    initSearch();
    initMobileDrawer();
    initMobileTabs();
    initCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


/* ── Patch Savor's --header-height CSS variable ─────────────
   Savor computes this from header-component.offsetHeight.
   Since we hide header-component, we override it with
   the height of our custom nav wrapper instead.
   ──────────────────────────────────────────────────────────── */
(function patchHeaderHeight() {
  function setHeight() {
    var outer = document.getElementById('nerosa-header-outer');
    if (!outer) return;
    var h = outer.offsetHeight;

    /* Set Savor's CSS variables */
    document.body.style.setProperty('--header-height', h + 'px');
    document.body.style.setProperty('--header-group-height', h + 'px');

    /* On homepage the nav overlays the hero — no padding needed.
       On all other pages, push MainContent down so nothing hides under the nav. */
    var main = document.getElementById('MainContent');
    if (main) {
      var template = main.getAttribute('data-template') || '';
      var isHome   = (template === 'index');
      main.style.paddingTop = isHome ? '0' : h + 'px';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setHeight);
  } else {
    setHeight();
  }
  window.addEventListener('load', setHeight);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setHeight, 100);
  }, { passive: true });
})();
